import {Item as DropdownItem} from '@wandb/weave/components/DropdownMenu';
import React, {ReactNode} from 'react';

type RunRowHeaderOptionProps = {
  disabled?: boolean;
  icon: ReactNode;
  label: ReactNode;
  onSelect: () => void;
};

export function RowHeaderMenuOption({
  disabled,
  icon,
  label,
  onSelect,
}: RunRowHeaderOptionProps) {
  return (
    <DropdownItem onSelect={onSelect} disabled={disabled}>
      {icon} {label}
    </DropdownItem>
  );
}
